import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/atoms/HeaderTags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Loader/loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/pageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/contexts/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"constants/fonts.ts\",\"import\":\"Sora\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true,\"variable\":\"--font-sora\"}],\"variableName\":\"soraFont\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"constants/fonts.ts\",\"import\":\"Quicksand\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true,\"variable\":\"--font-quicksand\"}],\"variableName\":\"quicksandFont\"}");
